import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-R",
  "use": "icon-R-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-R\">\n<path d=\"M40.8662 24.328C40.1462 23.656 39.0422 23.656 38.3702 24.328L29.9222 32.536L21.5702 24.232C20.8982 23.56 19.7942 23.56 19.1222 24.232C18.4502 24.904 18.4502 26.008 19.1222 26.68L27.4742 34.984C28.1942 35.704 29.1062 36.04 30.0182 36.04C30.9302 36.04 31.8422 35.704 32.5622 34.984L40.8182 26.776C41.5382 26.104 41.5382 25 40.8662 24.328Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol